import { Component, Host, h, Element, Prop, Listen, State } from '@stencil/core';
import { TileGalleryItemClickedEvent } from './sew-ws-tile-gallery.types';
import { getHeaderHeight } from '@sew/ui-components/src/utils/getHeaderHeight';

@Component({
    tag: 'sew-ws-tile-gallery',
    styleUrl: 'sew-ws-tile-gallery.scss',
    shadow: false,
})
export class SewWsTileGallery {
    @Element() host: HTMLSewWsTileGalleryElement;

    @Prop({ reflect: true }) noGrid = false;
    @Prop({ reflect: true }) noMargin = false;
    @Prop({ reflect: true }) theme: 'blue' | 'anthrazit' | 'red' | 'grey' = 'blue';
    @Prop() headline: string;
    @Prop() text: string;

    @State() open = false;
    @State() animationEnded = true;

    private itemWrapperElement: HTMLDivElement;
    private tileGalleryItems: HTMLSewWsTileGalleryItemElement[];

    @Listen('tileGalleryItemClicked')
    itemClickedHandler(event: CustomEvent<TileGalleryItemClickedEvent>): void {
        if (event.detail.open) {
            this.host.style.setProperty('--item-wrapper-height', this.itemWrapperElement.offsetHeight + 'px');

            //setTimeout(() => {
            const hostPosY =
                this.itemWrapperElement.getBoundingClientRect().top +
                window.scrollY -
                getHeaderHeight().scrolledHeight -
                40;

            console.log(hostPosY);

            window.scrollTo({
                top: hostPosY,
                behavior: 'smooth',
            });
            //}, 1000);
        } else {
            //setTimeout(() => {
            this.host.style.removeProperty('--item-wrapper-height');
            //}, 1000);
        }

        this.animationEnded = false;

        if (event.detail.open) {
            const resizeObserver = new ResizeObserver(() => {
                this.host.style.setProperty(
                    '--content-height',
                    event.detail.clicketItemContentElement.offsetHeight + 'px'
                );
            });

            resizeObserver.observe(event.detail.clicketItemContentElement);
        }

        setTimeout(() => (this.open = event.detail.open));
    }

    @Listen('resize', { target: 'window' })
    handleResize(): void {
        this.host.style.setProperty('--content-max-width', this.itemWrapperElement.offsetWidth + 'px');

        const hostPosLeft = this.itemWrapperElement.getBoundingClientRect().left;
        const hostPosTop = this.itemWrapperElement.getBoundingClientRect().top;

        for (let i = 0; i < this.tileGalleryItems.length; i++) {
            const item = this.tileGalleryItems[i] as HTMLElement;
            const itemPos = item.getBoundingClientRect();
            const itemLeft = itemPos.left - hostPosLeft;
            const itemTop = itemPos.top - hostPosTop;

            item.style.setProperty('--item-left', itemLeft + 'px');
            item.style.setProperty('--item-top', itemTop + 'px');
            item.style.setProperty('--item-width', itemPos.width + 'px');
            item.style.setProperty('--item-height', itemPos.height + 'px');
        }
    }

    private getAnchorLink = (): void => {
        const url = window.location.href;
        const hashtag = url.split('#')[1];
        const item = this.host.querySelector(`[tile-id="${hashtag}"]`) as HTMLSewWsTileGalleryItemElement;

        if (item) {
            item.openItem();
        }
    };

    componentDidRender() {
        this.handleResize();
    }

    componentDidLoad() {
        this.tileGalleryItems = Array.from(this.host.querySelectorAll('sew-ws-tile-gallery-item'));
        this.getAnchorLink();
        window.addEventListener('hashchange', () => this.getAnchorLink(), false);
    }

    render() {
        return (
            <Host class={{ 'no-headline': !this.headline }}>
                <div class="main-content-container">
                    <h2 innerHTML={this.headline}></h2>
                    <p innerHTML={this.text}></p>
                    <div
                        ref={el => (this.itemWrapperElement = el as HTMLDivElement)}
                        class={{
                            'item-wrapper': true,
                            'content-open': this.open,
                            'open-ended': this.open && this.animationEnded,
                        }}
                        onAnimationEnd={() => (this.animationEnded = true)}
                    >
                        <slot></slot>
                    </div>
                </div>
            </Host>
        );
    }
}
